import type { ProcessStep } from '../types/ProcessStep.interface'

export const getProcessStepDisplay = (processStep: ProcessStep): string => {
  if (processStep.stepDisplay) {
    // The name of the sequence
    return processStep.stepDisplay
  }
  const { commandName } = processStep

  if (commandName === 'execute_sequence_from_json') {
    // The name of the sequence - only return if the param exists and is not null/undefined
    const sequenceName = processStep.commandParams?.[0]
    if (sequenceName != null && sequenceName !== '') {
      return String(sequenceName)
    }
    // Fall back to command name if param is missing
    return processStep.commandName
  }

  return processStep.commandName
}
